import { User, UserRoles } from '../../../../../types/models/user/user.types';
import { RegisterQuery } from './LaunchingRegisterForm.query';
import { Formation } from '../../../../../types/models/formation/formation.types';

export interface RegisterFormProps {
  variant: RegisterFormVariants;
}

export enum RegisterFormVariants {
  AcheteurPublicPhysique = 'PUB',
  AcheteurPublicLive = 'PUB_live',
  CommercialFormation = 'COM_formation',
}

export interface RegisterFormSchema extends Omit<User, 'role'> {
  formations?: Formation[];
  department?: string;
}

export interface RegisterMutationVariables extends Partial<User> {
  role: UserRoles;
}

export type RegisterMutation = (
  variables: RegisterMutationVariables
) => ReturnType<typeof RegisterQuery>;
